import React, { useState } from 'react';
import { Content, Header } from '@backstage/core-components';
import { Button, Typography } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { FlexBox } from '../../global/FlexBox';
import { TeamsGrid } from '../components/TeamsGrid/TeamsGrid';
import { CreateTeamDrawer } from '../components/CreateTeamDrawer/CreateTeamDrawer';
import { useEditTeamDrawer } from '../components/EditTeamDrawer/EditTeamDrawer';

export default function TeamsPage() {
  const [isCreateTeamDrawerOpen, setIsCreateTeamDrawerOpen] = useState(false);
  const { openEditTeam } = useEditTeamDrawer();

  return (
    <>
      <Header
        pageTitleOverride="Teams"
        title={
          <FlexBox sx={{ justifyContent: 'space-between', width: '100%' }}>
            <Typography variant="h4">Teams</Typography>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={() => setIsCreateTeamDrawerOpen(true)}
            >
              Create New Team
            </Button>
          </FlexBox>
        }
        subtitle="Manage teams and their modifiers"
      />
      <Content>
        <TeamsGrid onEdit={openEditTeam} />
      </Content>
      <CreateTeamDrawer
        isOpen={isCreateTeamDrawerOpen}
        onOpen={() => setIsCreateTeamDrawerOpen(true)}
        onClose={() => setIsCreateTeamDrawerOpen(false)}
      />
    </>
  );
}
